import { FC, ReactNode, createContext, useContext, useMemo } from "react";

import type { PopupImportScheduleOption } from "./popupImportScheduleOptions";

type Ctx = {
  scheduleOptions: PopupImportScheduleOption[];
};

const PopupImportScheduleOptionsContext = createContext<Ctx | null>(null);

export const PopupImportScheduleOptionsProvider: FC<{
  scheduleOptions: PopupImportScheduleOption[];
  children: ReactNode;
}> = ({ scheduleOptions, children }) => {
  const value = useMemo(() => ({ scheduleOptions }), [scheduleOptions]);
  return (
    <PopupImportScheduleOptionsContext.Provider value={value}>
      {children}
    </PopupImportScheduleOptionsContext.Provider>
  );
};

export function usePopupImportScheduleOptions(): Ctx {
  const v = useContext(PopupImportScheduleOptionsContext);
  if (!v) {
    throw new Error(
      "usePopupImportScheduleOptions must be used within PopupImportScheduleOptionsProvider"
    );
  }
  return v;
}
